export default {"src":"/_next/static/media/successInput.2f2ada7c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};